import React, { useEffect, useRef, useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';

const ExitPopup = ({ open, title, info, button, setSessionExpired }) =>
{
	const countdownStart = 5;
	const [ countdown, setCountdown ] = useState(countdownStart);
	const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
	const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
	const clearTimers = () =>
	{
		if (timerRef.current) clearTimeout(timerRef.current);
		if (intervalRef.current) clearInterval(intervalRef.current);
	};

	const triggerLogout = async () =>
	{
		window.location.reload();
		clearTimers();
		setSessionExpired(false);
	};

	useEffect(() =>
	{
		if (!open) return;
		setCountdown(countdownStart);

		intervalRef.current = setInterval(() =>
		{
			setCountdown((prev) =>
			{
				if (prev <= 1)
				{
					clearInterval(intervalRef.current!);
					triggerLogout();

					return 0;
				}

				return prev - 1;
			});
		}, 1000);

		return clearTimers;
	}, [ open ]);

	return (
		<Dialog
			open={open}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			fullWidth
			maxWidth='sm'
		>
			<DialogContent>
				<div className='flexRow alignCntr justifyCntr'>
					<span className='mainHdngTxt textCntr'>{title}</span>
				</div>

				<div className='flexRow alignCntr justifyCntr mrgnTSM'>
					<span className='lightTxt textCntr ntwrkLineHeight'>{info}</span>
				</div>

				<div className='flexRow alignCntr justifyCntr mrgnTSM'>
					<span className='lightTxt textCntr'>
						Reloading automatically in {countdown} {countdown === 1 ? 'second' : 'seconds'}…
					</span>
				</div>
			</DialogContent>
			<DialogActions className='brdrTSM'>
				<span className='pdngXS'>
					<Button
						variant='contained'
						style={{ width: '500' }}
						className='whiteTxt'
						disableElevation disableRipple
						onClick={triggerLogout}
					>
						<b>{button}</b>
					</Button>
				</span>
			</DialogActions>
		</Dialog>
	);
};

export default ExitPopup;
